import CoreUtils from '../utils/CoreUtils';
import StringUtils from '../utils/StringUtils';

export default class Serialization {
  static serializeValue(value, metadataRule) {
    if (CoreUtils.isUndefinedOrNull(metadataRule))
      return value;

    switch (metadataRule.type) {
      case 'boolean':
        return Serialization.serializeBooleanValue(value, metadataRule);
      case 'number':
        return Serialization.serializeNumberValue(value, metadataRule);
      case 'string-list':
        return Serialization.serializeStringListValue(value, metadataRule);
      case 'select':
        return Serialization.serializeSelectValue(value, metadataRule);
      default:
        return value;
    }
  }

  static deserializeValue(value, metadataRule) {
    if (CoreUtils.isUndefinedOrNull(metadataRule))
      return value;

    switch (metadataRule.type) {
      case 'boolean':
        return Serialization.deserializeBooleanValue(value, metadataRule);
      case 'number':
        return Serialization.deserializeNumberValue(value, metadataRule);
      case 'string-list':
        return Serialization.deserializeStringListValue(value, metadataRule);
      case 'select':
        return Serialization.deserializeSelectValue(value, metadataRule);
      default:
        return value;
    }
  }

  static serializeBooleanValue(value, metadataRule) {
    if (!metadataRule.serializeAsString)
      return value;

    if (CoreUtils.isUndefinedOrNull(value))
      return '';

    return value ? '1' : '0';
  }

  static deserializeBooleanValue(value, metadataRule) {
    if (!metadataRule.serializeAsString)
      return value;

    if (CoreUtils.isUndefinedOrNull(value) || value === '')
      return null;

    return value === '1';
  }

  static serializeNumberValue(value, metadataRule) {
    if (!metadataRule.serializeAsString)
      return value;

    if (CoreUtils.isUndefinedOrNull(value) || isNaN(value))
      return '';

    return value.toString();
  }

  static deserializeNumberValue(value, metadataRule) {
    if (!metadataRule.serializeAsString)
      return value;

    if (CoreUtils.isUndefinedOrNull(value) || StringUtils.isEmptyString(value))
      return null;

    return metadataRule.allowFractional
      ? parseFloat(value)
      : parseInt(value);
  }

  static serializeStringListValue(values, metadataRule) {
    if (CoreUtils.isUndefinedOrNull(values) || !Array.isArray(values))
      return '';

    var filteredValues = values.map(
      value => StringUtils.isValidString(value)
        ? value.trim()
        : ''
    );

    filteredValues = StringUtils.sortStringArray(filteredValues, true);
    return StringUtils.join(filteredValues, '; ');
  }

  static deserializeStringListValue(value, metadataRule) {
    return StringUtils.sortStringArray(
      StringUtils.split(value, [';', ','], true),
      true
    );
  }

  static serializeSelectValue(value, metadataRule) {
    return CoreUtils.isDefinedAndNotNull(value)
      ? value.value
      : null;
  }

  static deserializeSelectValue(value, metadataRule) {
    var result = metadataRule.options.find(option => option.value === value);
    if (CoreUtils.isUndefinedOrNull(result))
      return null;

    return result;
  }
}